// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","header__content":"header_header__content__eDQmA","header__h1":"header_header__h1__Bqi9C","header__season":"header_header__season__iH13m"};